import type {FC, ReactNode} from 'react';
import {memo} from 'react';

import NotificationTopContainer from '../NotificationTopContainer/NotificationTopContainer';
import TopMenuLayout from '../TopMenuLayout/TopMenuLayout';
import TopMenuLayoutPublic from '../TopMenuLayoutPublic/TopMenuLayoutPublic';

interface Props {
  children: ReactNode;
  customMainClass?: string;
  withTopMenu?: boolean;
}

const MainContainerPublicPageWithColumn: FC<Props> = ({
  children,
  customMainClass = '',
  withTopMenu = true,
}) => {
  return (
    <main className={`MainContainerWithMenuLayout ${customMainClass}`}>
      <NotificationTopContainer />

      <div className="container">
        <TopMenuLayoutPublic />
        {withTopMenu ? (
          <div className="offsetMenuContainer">
            <TopMenuLayout />
          </div>
        ) : null}
      </div>
      {children}
    </main>
  );
};

export default memo(MainContainerPublicPageWithColumn);
